import { Component, Output, EventEmitter } from '@angular/core';
import { ActionSheetController } from 'ionic-angular';
import { App } from 'ionic-angular';
import { Input } from '@angular/core';

import { HousingUnit, User, Condominium, UIStrings } from '../../models/models';
import { AuthProvider } from '../../providers/auth/auth';
import { AlertController, ToastController } from 'ionic-angular';
import { UserProvider } from '../../providers/user/user';
import { UserEditPage } from '../../pages/user-edit/user-edit';
import { UserShowPage } from '../../pages/user-show/user-show';
import { MessageCreatePage } from '../../pages/message-create/message-create';


@Component({
	selector: 'user-item',
	templateUrl: 'user-item.html'
})
export class UserItemComponent {
	isLoading: boolean = false;

	@Output() refresh: EventEmitter<User> = new EventEmitter<User>();

	@Input() isFiscalIdentifierVisible = false;
	@Input() isAccountsVisible = false;

	@Input() public user: User;
	@Input() public condominium: Condominium = null;
	@Input() public housingUnit: HousingUnit = null;
	//ruolo con cui è elencato, per rimozione
	@Input() public role: string = null;

	/**
	Se false il menù interattivo non è visibile
	*/
	@Input() public isMenuVisible: boolean = true;
	@Input() public isShowable: boolean = true;

	private roles = {
		is_administrator: 'Amministratore',
		is_operator: 'Gestore',
		is_worker: 'Addetto',
		is_heatingreader: 'Termoletturista',
		is_admin: 'Sviluppatore',
		is_owner: 'Proprietario',
		is_resident: 'Residente'
	};

	/**
	Recupera il nav dinamicamente dall'app, per supportare l'inserimento nel menù globale fuori dalle pagine
	*/
	private get nav(): any {
		return this.app.getActiveNav();
	}

	constructor(
		public actionSheetCtrl: ActionSheetController,
		private alertCtrl: AlertController,
		private auth: AuthProvider,
		private app: App,
		//private nav: NavController,
		private toastCtrl: ToastController,
		private users: UserProvider,
	) {
	}

	/**
	Verifica se può eliminare l'utente
	- superuser si
	*/
	get isDeletable(): boolean {
		if (!this.auth.user) return false;

		//superutenti tolgono tutti tranne admin
		if (this.auth.hasRole(['is_admin', 'is_owner'])) return true;

		return false;
	}


	/*
	Controlla se può rimuovere ruoli:
	- admin e operatori sempre
	- amministratori del condominio di questa U.I. possono ai non amministratori
	- proprietari della U.I. solo se il ruolo è residente
	*/
	get isRemovable(): boolean {
		if (this.condominium) {
			return this.auth.canRemoveCondominiumUser(this.condominium, this.user, this.role);
		} else if (this.housingUnit) {
			return this.auth.canRemoveHousingUnitUser(this.housingUnit, this.user, this.role);
		}

		return false;
	}

	public onClick() {
		if (this.isShowable) {
			this.goToUserShow()
		}
	}

	public showMenu(event) {
		event.stopPropagation();

		let self = this;
		let buttons = [];
		if (this.auth.canUserShow(this.user)) {
			buttons.push({
				text: UIStrings.SHOW,
				icon: 'eye',
				handler: () => {
					self.goToUserShow();
				}
			});
			buttons.push({
				text: 'Invia messaggio',
				icon: 'mail',
				handler: () => {
					self.goToMessageCreate();
				}
			});
		}
		if (this.auth.canUserEdit(this.user)) {
			buttons.push({
				text: UIStrings.EDIT,
				role: 'destructive',
				icon: 'create',
				handler: () => {
					self.goToUserEdit();
				}
			});
		}
		if (this.isRemovable) {
			buttons.push({
				text: UIStrings.ROLE_REMOVE + ' ' + this.roles[this.role],
				role: 'destructive',
				icon: 'remove',
				handler: () => {
					self.showRemoveRoleConfirm();
				}
			});
		}
		if (this.isDeletable) {
			buttons.push({
				text: UIStrings.DELETE,
				role: 'destructive',
				icon: 'trash',
				handler: () => {
					self.showDestroyUserConfirm();
				}
			});
		}
		buttons.push({
			text: UIStrings.MENU_CLOSE,
			role: 'cancel',
			icon: 'undo',
			handler: () => { }
		});

		let title = 'Utente ';
		let subtitle = '';
		switch (this.user.type) {
			case 'company':
				title = 'Azienda ';
				subtitle = 'P.I. ' + this.user.vat_number;
				break;
			case 'person':
				title = 'Persona ';
				subtitle = 'C.F. ' + this.user.fiscal_code;
				break;
			default:
				console.warn('Tipo di utente non valido: ' + this.user.type);
				break;
		}
		title += this.user.name;
		if (this.user.surname) title += ' ' + this.user.surname;

		let options = {
			title: title,
			subTitle: subtitle,
			buttons: buttons
		};

		let actionSheet = this.actionSheetCtrl.create(options);
		actionSheet.present();
	}

	goToMessageCreate() {
		this.nav.push(MessageCreatePage, { user: this.user });
	}

	goToUserEdit() {
		if (!this.user) {
			console.error("Utente non specificato per user-item");
			return;
		}
		this.nav.push(UserEditPage, { user: this.user });
	}

	goToUserShow() {
		if (!this.user) {
			console.error("Utente non specificato per user-item");
			return;
		}
		this.nav.push(UserShowPage, { user: this.user });
	}

	public openURL(url: string, event) {
		event.stopPropagation()
		/*
		if ((<any>navigator).app) {
			(<any>navigator).app.loadUrl(url, { openExternal: true })
		} else {
			window.open(url, '_system');
		}
		*/
		window.open(url, '_system');
	}

	showDestroyUserConfirm() {
		if (!this.user) {
			console.error("Utente non specificato per user-item");
			return;
		}
		let self = this;
		let user = this.user;

		let confirm = this.alertCtrl.create({
			title: "Eliminare l'utente dal server?",
			message: "Vuoi davvero eliminare l'utente '" + user.name + " " + user.surname + "' - " + user.fiscal_code + " " + user.vat_number + "?",
			buttons: [
				{
					text: UIStrings.DIALOG_CANCEL,
					role: 'cancel'
				}, {
					text: UIStrings.DELETE,
					handler: () => {
						self.users.destroy(user).then((success: boolean) => {
							if (success) {
								let toast = self.toastCtrl.create({
									message: 'Utente eliminato',
									position: 'middle',
									duration: 3000,
									cssClass: "light"
								});
								toast.present();
							} else {
								let toast = self.toastCtrl.create({
									message: "Potrebbe essersi verificato un errore eliminando l'utente",
									position: 'middle',
									duration: 3000,
									cssClass: "danger"
								});
								toast.present();
							}
							self.refresh.emit(user);
						}).catch(error => {
							console.error("Errore cancellando l'utente", error);
							let toast = self.toastCtrl.create({
								message: "Errore cancellando l'utente",
								position: 'middle',
								duration: 3000,
								cssClass: "danger"
							});
							toast.present();
							self.refresh.emit(user);
						});
					}
				}
			]
		});
		confirm.present();
	}

	showRemoveRoleConfirm() {
		if (!this.user) {
			console.error("Utente non specificato per user-item");
			return;
		}
		if (!this.role) {
			console.error("Ruolo non specificato per user-item");
			return;
		}
		let self = this;
		let user = this.user;
		let role = this.role;

		let roleName = this.roles[role];

		if (this.condominium) {//rimozione contestuale al condominio
			console.log('Pivot utente condominio:', this.user.pivot);
			let self = this;
			let alertConfirm = this.alertCtrl.create({
				title: 'Rimuovi utente',
				message: "Si vuole veramente rimuovere il ruolo " + self.roles[role] + " di '" + user.name + " " + user.surname + "' - " + user.fiscal_code + " " + user.vat_number + ' dal condominio?',
				buttons: [{
					text: UIStrings.DIALOG_CANCEL,
					role: 'cancel',
					handler: () => { }
				}, {
					text: UIStrings.ROLE_REMOVE,
					handler: () => {
						self.isLoading = true;
						self.users.detachCondominiumRole(user.pivot, role)
							.then((result: boolean) => {
								self.refresh.emit(user);
								if (result) {
									let toast = self.toastCtrl.create({
										message: 'Ruolo ruolo ' + self.roles[role] + ' di ' + user.name + " " + user.surname + "' - " + user.fiscal_code + " " + user.vat_number + ' rimosso dal condominio',
										position: 'middle',
										duration: 3000,
										cssClass: "light"
									});
									toast.present();
								} else {
									let toast = self.toastCtrl.create({
										message: 'Potrebbe essersi verificato un errore rimuovendo il ruolo ' + self.roles[role] + ' di '
											+ user.name + " " + user.surname + "' - " + user.fiscal_code + " " + user.vat_number + ' dal condominio',
										position: 'middle',
										duration: 3000,
										cssClass: "danger"
									});
									toast.present();
								}
							}).catch((error: any) => {
								console.error('Errore rimuovendo il ruolo dell\'utente dal condominio:', error);
								self.refresh.emit(user);
								let toast = self.toastCtrl.create({
									message: 'Errore rimuovendo il ruolo ' + self.roles[role] + ' di ' + user.name + ' ' + user.surname + ' dal condominio',
									position: 'middle',
									duration: 3000,
									cssClass: "danger"
								});
								toast.present();
							});
					}
				}]
			});
			alertConfirm.present();
		} else if (this.housingUnit) {
			//rimozione contestuale all'unità immobliare

			let self = this;
			let alertConfirm = this.alertCtrl.create({
				title: 'Rimuovi utente',
				message: 'Si vuole veramente rimuovere il ruolo ' + self.roles[role] + ' dell\'utente dall\'unità abitativa?',
				buttons: [{
					text: UIStrings.DIALOG_CANCEL,
					role: 'cancel',
					handler: () => { }
				}, {
					text: UIStrings.ROLE_REMOVE,
					handler: () => {
						self.isLoading = true;
						self.users.detachHousingUnitRole(user.pivot, role)
							.then((result: boolean) => {
								self.refresh.emit(user);
								if (result) {
									let toast = self.toastCtrl.create({
										message: 'Ruolo dell\'utente rimosso dall\'unità abitativa',
										position: 'middle',
										duration: 3000,
										cssClass: "light"
									});
									toast.present();
								} else {
									let toast = self.toastCtrl.create({
										message: 'Potrebbe essersi verificato un errore rimuovendo il ruolo dell\'utente dall\'unità abitativa',
										position: 'middle',
										duration: 3000,
										cssClass: "danger"
									});
									toast.present();
								}
							}).catch((error: any) => {
								console.error('Errore rimuovendo il ruolo dell\'utente dall\'unità abitativa:', error);
								self.refresh.emit(user);
								let toast = self.toastCtrl.create({
									message: 'Errore rimuovendo il ruolo dell\'utente dall\'unità abitativa',
									position: 'middle',
									duration: 3000,
									cssClass: "danger"
								});
								toast.present();
							});
					}
				}]
			});
			alertConfirm.present();
		} else {
			//rimozione del ruolo dall'utente

			let confirm = this.alertCtrl.create({
				title: "Rimuovere " + roleName + "?",
				message: "Vuoi davvero rimuovere il ruolo all'utente '" + user.name + " " + user.surname + "' - " + user.fiscal_code + " " + user.vat_number + "?",
				buttons: [
					{
						text: UIStrings.DIALOG_CANCEL,
						role: 'cancel'
					}, {
						text: UIStrings.ROLE_REMOVE,
						handler: () => {
							user[role] = false;
							self.users.update(user).then((user: User) => {
								if (user && !user[role]) {
									let toast = self.toastCtrl.create({
										message: 'Ruolo rimosso',
										position: 'middle',
										duration: 3000,
										cssClass: "light"
									});
									toast.present();
								} else {
									let toast = self.toastCtrl.create({
										message: "Potrebbe essersi verificato un errore rimuovendo il ruolo",
										position: 'middle',
										duration: 3000,
										cssClass: "danger"
									});
									toast.present();
								}
								self.refresh.emit(user);
							}).catch(error => {
								console.error("Errore rimuovendo il ruolo", error);
								let toast = self.toastCtrl.create({
									message: "Errore rimuovendo il ruolo",
									position: 'middle',
									duration: 3000,
									cssClass: "danger"
								});
								toast.present();
								self.refresh.emit(user);
							});
						}
					}
				]
			});
			confirm.present();
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/user-item/user-item.ts